import { useDataChannel } from "@livekit/components-react";
import classNames from "./FloatingEmojis.module.css";
import { FloatingEmojiProps } from "../../../types";
import { useFloatingEmojis } from "../../../hooks/emoji";

const decoder = new TextDecoder();

function FloatingEmoji({ emoji, name, startX, duration }: FloatingEmojiProps) {
  return (
    <div
      className={classNames.FloatingEmojis_Item}
      style={
        {
          "--start-x": `${startX}px`,
          "--duration": `${duration}s`,
        } as React.CSSProperties
      }
    >
      <div className={classNames.FloatingEmojis_Emoji}>{emoji}</div>
      <div className={classNames.FloatingEmojis_Name}>{name}</div>
    </div>
  );
}

export default function FloatingEmojis() {
  const { emojis, showFloatingEmoji } = useFloatingEmojis();

  useDataChannel("emoji", (message) => {
    if (!message.from || !message.from.metadata) return;

    const emoji = decoder.decode(message.payload);
    const metadata = JSON.parse(message.from.metadata);
    const name = metadata.name ?? "Guest";
    showFloatingEmoji(emoji, name);
  });

  return (
    <div className={classNames.FloatingEmojis}>
      {emojis.map((emoji) => (
        <FloatingEmoji key={emoji.id} {...emoji} />
      ))}
    </div>
  );
}
